import { request } from "./client";
import type {
  CreateJobRequest,
  CreateJobResponse,
  JobStatusResponse,
} from "./types";

export function createJob(
  payload: CreateJobRequest,
): Promise<CreateJobResponse> {
  return request<CreateJobResponse>("/api/jobs", {
    method: "POST",
    json: payload,
  });
}

export function getJob(jobId: string): Promise<JobStatusResponse> {
  return request<JobStatusResponse>(`/api/jobs/${jobId}`);
}

export function cancelJob(jobId: string): Promise<JobStatusResponse> {
  return request<JobStatusResponse>(`/api/jobs/${jobId}/cancel`, {
    method: "POST",
  });
}
